import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from '../../app/apiBaseQuery';

export const AdminAPI = createApi({
    reducerPath: 'AdminAPI',
    baseQuery,
    endpoints: (builder) => ({
        getLocations: builder.mutation({
            query: (params) => ({
                url: 'admin/getAllLocationsForAdmin',
                method: 'POST',
                body: params,
            }),
        }),
        getUsers: builder.mutation({
            query: (params) => ({
                url: 'admin/getAllUsers',
                method: 'POST',
                body: params,
            }),
        }),
        acceptOrRejectAdContent: builder.mutation({
            query: (params) => ({
                url: 'admin/approveOrRejectAdContent',
                method: 'POST',
                body: params,
            }),
        }),
        userStatusChange: builder.mutation({
            query: (params) => ({
                url: 'admin/toggleUserStatus',
                method: 'POST',
                body: params,
            }),
        }),
        getSubscriptionPlans: builder.mutation({
            query: (params) => ({
                url: 'admin/getSubscriptionPlans',
                method: 'POST',
                body: params,
            }),
        }),
        createOrUpdateSubscriptionPlan: builder.mutation({
            query: (params) => ({
                url: 'admin/createOrUpdateSubscriptionPlan',
                method: 'POST',
                body: params,
            }),
        }),
        getAdminCampaign: builder.mutation({
            query: (params) => ({
                url: 'admin/getAllAdminCampaigns',
                method: 'POST',
                body: params,
            }),
        }),
        createOrUpdateCampaign: builder.mutation({
            query: (params) => ({
                url: 'admin/createOrUpdateAdminCampaign',
                method: 'POST',
                body: params,
            }),
        }),
        deleteAdminCampaign: builder.mutation({
            query: (params) => ({
                url: 'admin/deleteAdminCampaign',
                method: 'POST',
                body: params,
            }),
        }),
        getUserSubscription: builder.mutation({
            query: (params) => ({
                url: 'admin/getUserSubscription',
                method: 'POST',
                body: params,
            }),
        }),
        getAllDefaultAds: builder.mutation({
            query: (params) => ({
                url: 'admin/listAllDefaultAds',
                method: 'POST',
                body: params,
            }),
        }),
        createOrUpdateDefaultAd: builder.mutation({
            query: (params) => ({
                url: 'admin/createOrUpdateDefaultAd',
                method: 'POST',
                body: params,
            }),
        }),
        deleteDefaultAd: builder.mutation({
            query: (params) => ({
                url: 'admin/deleteDefaultAd',
                method: 'POST',
                body: params,
            }),
        }),
        markAsDefaultAd: builder.mutation({
            query: (params) => ({
                url: 'admin/markAsDefaultAd',
                method: 'POST',
                body: params,
            }),
        }),
        getAdminRedeemRequests: builder.mutation({
            query: (params) => ({
                url: 'admin/getAdminRedeemRequests',
                method: 'POST',
                body: params,
            }),
        }),
        getAllSeoMeta: builder.mutation({
            query: (params) => ({
                url: 'admin/getAllSeoMeta',
                method: 'POST',
                body: params,
            }),
        }),
        addOrUpdateSeoMeta: builder.mutation({
            query: (params) => ({
                url: 'admin/addOrUpdateSeoMeta',
                method: 'POST',
                body: params,
            }),
        }),
        deleteSeoMeta: builder.mutation({
            query: (params) => ({
                url: 'admin/deleteSeoMeta',
                method: 'POST',
                body: params,
            }),
        }),
        getAdminGraphsDetails: builder.mutation({
            query: (params) => ({
                url: 'admin/getAdminGraphsDetails',
                method: 'POST',
                body: params,
            }),
        }),
        getContactQueries: builder.mutation({
            query: (params) => ({
                url: 'user/getContactQueries',
                method: 'POST',
                body: params,
            }),
        }),
        getGeneralSettings: builder.query({
            query: () => ({
                url: 'admin/getGeneralSettings',
                method: 'GET',
            }),
        }),
        updateGeneralSettings: builder.mutation({
            query: (params) => ({
                url: 'admin/updateGeneralSettings',
                method: 'POST',
                body: params,
            }),
        }),
        updateHeroSection: builder.mutation({
            query: (params) => ({
                url: 'admin/upsertHero',
                method: 'POST',
                body: params,
            }),
        }),
        updateAboutUsSection: builder.mutation({
            query: (params) => ({
                url: 'admin/upsertAboutUsPage',
                method: 'POST',
                body: params,
            }),
        }),
        getAboutPage: builder.query({
            query: () => ({
                url: 'admin/getAboutPage',
                method: 'GET',
            }),
        }),
        updateSolutionSection: builder.mutation({
            query: (params) => ({
                url: 'admin/upsertSolution',
                method: 'POST',
                body: params,
            }),
        }),
        updateManageSection: builder.mutation({
            query: (params) => ({
                url: 'admin/upsertManage',
                method: 'POST',
                body: params,
            }),
        }),
        updateIndustriesSection: builder.mutation({
            query: (params) => ({
                url: 'admin/upsertindustires',
                method: 'POST',
                body: params,
            }),
        }),
        //     query: (params) => ({
        //         url: 'admin/upsertStatsVideo',
        //         method: 'POST',
        //         body: params,
        //     }),
        // }),
        updateWhyChooseUsSection: builder.mutation({
            query: (params) => ({
                url: 'admin/upsertWCU',
                method: 'POST',
                body: params,
            }),
        }),
        updateHomeFaqSection: builder.mutation({
            query: (params) => ({
                url: 'admin/upsertFAQImage',
                method: 'POST',
                body: params,
            }),
        }),
        getHomePageAll: builder.query({
            query: () => ({
                url: 'admin/getHomepageAll',
                method: 'GET',
            }),
        }),
        getAllStaticPages: builder.query({
            query: (params) => ({
                url: 'admin/getAllStaticPages',
                method: 'GET',
                params
            }),
        }),
        addOrUpdateStaticPage: builder.mutation({
            query: (params) => ({
                url: 'admin/addOrUpdateStaticPage',
                method: 'POST',
                body: params,
            }),
        }),
        deleteStaticPage: builder.mutation({
            query: (params) => ({
                url: 'admin/deleteStaticPage',
                method: 'POST',
                body: params,
            }),
        }),

        getAllBlogs: builder.query({
            query: ({ page = 1, limit = 10, search = "" } = {}) => ({
                url: 'admin/getAllBlogs',
                method: 'GET',
                params: { page, limit, search },
            }),
        }),
        getBlogById: builder.query({
            query: (id) => ({
                url: `admin/getBlogById/${id}`,
                method: 'GET',
            }),
        }),
        createOrUpdateBlog: builder.mutation({
            query: (data) => ({
                url: 'admin/createOrUpdateBlog',
                method: 'POST',
                body: data,
            }),
        }),
        deleteBlog: builder.mutation({
            query: (params) => ({
                url: 'admin/deleteBlog',
                method: 'POST',
                body: params,
            }),
        }),


        getAllJobs: builder.query({
            query: ({ search = "", employmentType = "", page = 1, limit = 10 } = {}) => ({
                url: `admin/getAllJobsForAdmin?search=${encodeURIComponent(search)}&employmentType=${employmentType}&page=${page}&limit=${limit}`,
                method: 'GET',
            }),
        }),
        getAllAgreement: builder.query({
            query: ({ search = "", status = "", page = 1, limit = 10, employerId, type = ""} = {}) => ({
                url: `admin/getAllAgreements?search=${encodeURIComponent(search)}&status=${status}&page=${page}&limit=${limit}&employerId=${employerId}&type=${type}`,
                method: 'GET',
            }),
        }),
        getInterviewJobStats: builder.query({
            query: (jobId) => ({
                url: `admin/interview/job-stats/${jobId}`,
                method: "GET",
            }),
        }),
        shootjobMail: builder.mutation({
            query: (params) => ({
                url: 'admin/shootJobMail',
                method: 'POST',
                body: params,
            }),
        }),
        initializeInterview: builder.mutation({
            query: (params) => ({
                url: 'admin/interview/initialize',
                method: 'POST',
                body: params,
            }),
        }),
        sendAnswer: builder.mutation({
            query: (params) => ({
                url: 'admin/interview/answer',
                method: 'POST',
                body: params,
            }),
        }),
        getInterviewSummary: builder.query({
            query: (sid) => ({
                url: `admin/interview/summary/${sid}`,
                method: 'GET',
            }),
        }),
        rtcToken: builder.mutation({
            query: (params) => ({
                url: 'admin/webRtcToken',
                method: 'POST',
                body: params,
            }),
        }),
        signDocument: builder.mutation({
            query: (params) => ({
                url: 'admin/signDocument',
                method: 'POST',
                body: params,
            }),
        }),
        signFinalDocument: builder.mutation({
            query: (params) => ({
                url: 'admin/signFinalDocument',
                method: 'POST',
                body: params,
            }),
        }),
        endInterview: builder.mutation({
            query: (params) => ({
                url: 'admin/interview/end',
                method: 'POST',
                body: params,
            }),
        }),
        rejectCandidate: builder.mutation({
            query: (params) => ({
                url: 'admin/rejectCandidate',
                method: 'POST',
                body: params,
            }),
        }),
        affiliateCommissions: builder.mutation({
            query: (params) => ({
                url: 'admin/getAllAffiliateCommissions',
                method: 'POST',
                body: params,
            }),
        }),
        adminPayAffiliateCommissions: builder.mutation({
            query: (params) => ({
                url: 'admin/adminPayAffiliateCommissions',
                method: 'POST',
                body: params,
            }),
        }),
        getAllPrompts: builder.query({
            query: () => ({
                url: 'ai/getAllRolePrompts',
                method: 'GET'
            }),
        }),
        addOrUpdatePrompt: builder.mutation({
            query: (params) => ({
                url: 'ai/saveRolePrompt',
                method: 'POST',
                body: params,
            }),
        }),
        getAllQuestions: builder.query({
            query: () => ({
                url: '/ai/admin/getAllQuestions',
                method: 'GET',
            }),
            providesTags: ['Questions'],
        }),
        addOrUpdateQuestion: builder.mutation({
            query: (body) => ({
                url: '/ai/admin/saveQuestion',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['Questions'],
        }),
    }),
});

export const {
    useGetLocationsMutation,
    useGetUsersMutation,
    useAcceptOrRejectAdContentMutation,
    useUserStatusChangeMutation,
    useGetSubscriptionPlansMutation,
    useCreateOrUpdateSubscriptionPlanMutation,
    useGetAdminCampaignMutation,
    useCreateOrUpdateCampaignMutation,
    useDeleteAdminCampaignMutation,
    useGetUserSubscriptionMutation,
    useGetAllDefaultAdsMutation,
    useCreateOrUpdateDefaultAdMutation,
    useDeleteDefaultAdMutation,
    useMarkAsDefaultAdMutation,
    useGetAdminRedeemRequestsMutation,
    useGetAllSeoMetaMutation,
    useAddOrUpdateSeoMetaMutation,
    useDeleteSeoMetaMutation,
    useGetAdminGraphsDetailsMutation,
    useGetContactQueriesMutation,
    useUpdateGeneralSettingsMutation,
    useGetGeneralSettingsQuery,
    useUpdateHeroSectionMutation,
    useUpdateAboutUsSectionMutation,
    useGetAboutPageQuery,
    useUpdateSolutionSectionMutation,
    useUpdateManageSectionMutation,
    useUpdateIndustriesSectionMutation,
    useUpdateWhyChooseUsSectionMutation,
    useUpdateHomeFaqSectionMutation,
    useGetHomePageAllQuery,
    useGetAllStaticPagesQuery,
    useAddOrUpdateStaticPageMutation,
    useDeleteStaticPageMutation,
    useGetAllJobsQuery,
    useShootjobMailMutation,
    useInitializeInterviewMutation,
    useSendAnswerMutation,
    useGetInterviewSummaryQuery,
    useRtcTokenMutation,
    useGetAllAgreementQuery,
    useSignDocumentMutation,
    useSignFinalDocumentMutation,
    useGetInterviewJobStatsQuery,
    useEndInterviewMutation,
    useRejectCandidateMutation,
    useAffiliateCommissionsMutation,
    useAdminPayAffiliateCommissionsMutation,
    useGetAllPromptsQuery,
    useAddOrUpdatePromptMutation,
    useGetAllQuestionsQuery,
    useAddOrUpdateQuestionMutation,
    useGetAllBlogsQuery,
    useGetBlogByIdQuery,
    useCreateOrUpdateBlogMutation,
    useDeleteBlogMutation,
} = AdminAPI;